import { render, staticRenderFns } from "./GeneralCosts.vue?vue&type=template&id=e8ad0b68&scoped=true&"
import script from "./GeneralCosts.vue?vue&type=script&lang=js&"
export * from "./GeneralCosts.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCosts.vue?vue&type=style&index=0&id=e8ad0b68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ad0b68",
  null
  
)

export default component.exports